/**
 * Community Notification Card
 * Shared card component for community notifications showing cover image,
 * title, and location.
 */

interface CommunityNotificationCardProps {
  coverImageUrl?: string | null
  title: string
  location?: string | null
  onClick?: (e: React.MouseEvent) => void
}

export function CommunityNotificationCard({
  coverImageUrl,
  title,
  location,
  onClick,
}: CommunityNotificationCardProps) {
  return (
    <div
      className={`relative mt-2 h-[357.5px] mx-auto md:w-[520px] rounded-2xl overflow-hidden border border-card${onClick ? " cursor-pointer" : ""}`}
      onClick={onClick}
    >
      {coverImageUrl ? (
        <img src={coverImageUrl} alt={title} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full bg-card flex items-center justify-center">
          <span className="text-stone text-sm">No cover image</span>
        </div>
      )}
      <div
        className="absolute inset-0 backdrop-blur-[1px]"
        style={{
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.12) 25%, rgba(0,0,0,0.35) 55%, rgba(0,0,0,0.7) 80%, rgba(0,0,0,1) 100%)",
        }}
      />
      <div className="absolute bottom-0 left-0 right-0 p-[20px]">
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-[20px] text-white truncate leading-[20px]">
            {title}
          </span>
          {location && <span className="text-white/80 text-[13px] leading-[20px]">{location}</span>}
        </div>
      </div>
    </div>
  )
}
